export const BASE_URL = process.env.VUE_APP_SERVICE_BASE_URL;
export const REDIRECT_URL = process.env.VUE_APP_REDIRECT_URL;
